export default "__VITE_ASSET__df91444d__"